var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: { showFooter: false, showTitle: false, design: "v3" },
          on: {
            cancel: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("div", { staticClass: "plan-limit-warning" }, [
            _c(
              "div",
              {
                staticClass: "plan-limit-warning-icon",
                class: _vm.iconColorClass,
              },
              [
                _vm.isUsageType
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          width: "48",
                          height: "48",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z",
                          },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", y1: "9", x2: "12", y2: "13" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", y1: "17", x2: "12.01", y2: "17" },
                        }),
                      ]
                    )
                  : _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          width: "48",
                          height: "48",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: { cx: "12", cy: "12", r: "10" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", y1: "8", x2: "12", y2: "12" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", y1: "16", x2: "12.01", y2: "16" },
                        }),
                      ]
                    ),
              ]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "plan-limit-warning-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "plan-limit-warning-message" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "plan-limit-warning-actions" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v("Tamam")]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }